module.exports = __webpack_public_path__ + "static/media/logo.f7b16065.png";